import { Component, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { HospitalTitlecasePipe } from "../../../../../../pipes/hospital-titlecase.pipe";

@Component({
  selector: 'app-modal-open-to-market-curve-30-days',
  standalone: true,
  imports: [CommonModule, HospitalTitlecasePipe],
  templateUrl: './modal-open-to-market-curve-30-days.component.html',
  styleUrl: './modal-open-to-market-curve-30-days.component.css'
})
export class ModalOpenToMarketCurve30DaysComponent implements OnInit, OnDestroy {
  @Output() isModalOpen = new EventEmitter<boolean>()
  @Input() curvePointData: any = {};
  @Input() widgetTitle: string = '';
  activeIndexes: number[] = [];

  Regioni: any[] = [];
  medicineId: number = 0;
  countryId: number = 1; // Default to Italy
  isLoading: boolean = true;
  // "dd/MM/yyyy - dd/MM/yyyy" of the clicked series' period, '' when not available (e.g. Mese 0)
  periodRangeLabel: string = '';


  constructor (private dataService: DataService) { }

  ngOnInit () {
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';

    this.medicineId = sessionStorage.getItem('medicineId') ? parseInt(sessionStorage.getItem('medicineId')!, 10) : 0;
    this.countryId = sessionStorage.getItem('countryId') ? parseInt(sessionStorage.getItem('countryId')!, 10) : 1;

    const start = this.formatPeriodDate(this.curvePointData.startPeriodDate);
    const end = this.formatPeriodDate(this.curvePointData.endPeriodDate);
    this.periodRangeLabel = start && end ? `${start} - ${end}` : '';

    // The backend already returns the cumulative contributions up to the selected period:
    // the response is displayed as it is, without accumulating anything here.
    const request$ = this.curvePointData.type === 'Forecast'
      ? this.dataService.getRegionsContributorsOpenToMarket30Days(this.medicineId, this.countryId, this.curvePointData.selectedPeriod)
      : this.dataService.getRegionsContributorsOpenToMarketActual30Days(this.medicineId, this.countryId, this.curvePointData.selectedPeriod);

    request$.subscribe({
      next: (data) => {
        this.isLoading = false;
        this.Regioni = Array.isArray(data) ? data : [];
        this.Regioni.sort((a, b) => b.potentialPercentage - a.potentialPercentage);
        this.Regioni.forEach(region => {
          (region.hospitals || []).sort((a: any, b: any) => b.hospitalPercentage - a.hospitalPercentage);
        });
      },
      error: (err) => {
        // Existing empty state ("Nessun dato disponibile")
        this.isLoading = false;
        this.Regioni = [];
        // console.log('error: ', err);
      },
    });
  }

  // "2026-03-18" (optionally with a time) -> "18/03/2026", read as a calendar date (no UTC shift)
  private formatPeriodDate (date: string | null | undefined): string {
    const m = String(date ?? '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
  }

  toggleAccordion (index: number) {
    const i = this.activeIndexes.indexOf(index);
    if (i > -1) {
      // già attivo → rimuovilo
      this.activeIndexes.splice(i, 1);
    } else {
      // non attivo → aggiungilo
      this.activeIndexes.push(index);
    }
  }

  ngOnDestroy (): void {
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  closeModal () {
    this.isModalOpen.emit(false);
  }
}
